import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { unlinkImageFromMenuItem } from 'apis/mips/api';
import { getErrorContent } from 'common/utils';

import { PhotoShootQueryKeys } from '../constants/queryKeys';

export type UseUnlinkMutationArgs = {
  venueId: string;
  token: string | null;
};

export const useUnlinkMutation = ({ venueId, token }: UseUnlinkMutationArgs) => {
  const [loadingItems, setLoadingItems] = useState<Set<string>>(new Set());
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ itemId, imageId }: { itemId: string; imageId: string }) =>
      unlinkImageFromMenuItem(venueId, itemId, imageId, token),
    {
      onError: error => toast.error(getErrorContent(error) || ''),
      onSuccess: res => queryClient.setQueryData(PhotoShootQueryKeys.GET_PHOTO_SHOOT(venueId, token), res.data),
      onMutate: ({ itemId }) =>
        setLoadingItems(prevState => {
          const newState = new Set(prevState);
          newState.add(itemId);
          return newState;
        }),
      onSettled: (_, __, { itemId }) =>
        setLoadingItems(prevState => {
          const newState = new Set(prevState);
          newState.delete(itemId);
          return newState;
        }),
    },
  );

  return { mutation, loadingItems };
};
